<template>
  <div class="regulatory-update-address-summary">
    <HeadingDisplay title="Endereço" head="Revisão de dados" />
    <ContentDisplay
      :blocks-length="2"
      footer-label="Mudar endereço"
      class="regulatory-update-address-summary__content-display"
      @click="goToAddNewAddress"
    >
      <template #content-block-1>
        <HeadingDisplay
          size="small"
          :title="addressTitle"
          :head="zipcode"
          :subtitle="complement"
        />
      </template>
      <template #content-block-2>
        <ListDisplay
          v-if="neighborhood && neighborhood.length"
          class="regulatory-update-address-summary__neighborhood"
          title="Bairro"
          :value="neighborhood"
          align-vertical
        />
        <ListDisplay
          title="Cidade e estado"
          :value="cityAndState"
          align-vertical
        />
      </template>
    </ContentDisplay>
    <Message>
      <template #description>
        Declaro que resido no endereço cadastrado e responsabilizo-me civil,
        administrativa e criminalmente pela veracidade das informações
        fornecidas.
      </template>
    </Message>
    <ButtonContainer class="regulatory-update-address-summary__footer">
      <template #button-primary>
        <ButtonPrimary
          size="large"
          label="Continuar"
          :loading="isButtonLoading"
          @click="goToNextPage"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  HeadingDisplay,
  ContentDisplay,
  MessageFoundation as Message,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    HeadingDisplay,
    ContentDisplay,
    Message,
    ListDisplay,
    ButtonContainer,
    ButtonPrimary
  }
})
export default class RegulatoryUpdateAddressSummary extends Vue {
  @Prop({ type: String, required: true })
  public zipcode!: string;

  @Prop({ type: String, required: true })
  public street!: string;

  @Prop({ type: [String, Number], default: '' })
  public number!: string;

  @Prop({ type: String, default: '' })
  public neighborhood!: string;

  @Prop({ type: String, required: true })
  public city!: string;

  @Prop({ type: String, required: true })
  public state!: string;

  @Prop({ type: String, default: '' })
  public complement!: string;

  @Prop({ type: Boolean, default: false })
  public isButtonLoading!: boolean;

  @Emit()
  public goToAddNewAddress() {}

  @Emit()
  public saveAddressAndGoToNextPage() {}

  public goToNextPage() {
    this.saveAddressAndGoToNextPage();
  }

  public get addressTitle() {
    if (!!this.number && this.number.length) {
      return `${this.street}, ${this.number}`;
    }

    return this.street;
  }

  public get cityAndState() {
    return `${this.city} - ${this.state}`;
  }
}
</script>

<style lang="less" scoped>
.regulatory-update-address-summary {
  padding-bottom: @size-spacing-x1800;

  &__content-display {
    margin-top: @size-spacing-x800;
    margin-bottom: @size-spacing-x500;
  }

  &__neighborhood {
    margin-bottom: @size-spacing-x400;
  }

  &__footer {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: @background-secondary;
    z-index: 1;
  }
}
</style>
